import { createApiEffect } from '@/features/api/common/create-api-effect'
import { LoadingCourse } from '@/features/api/learning/types'

export const getCourseFx = createApiEffect<number, LoadingCourse>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/course-app/courses/${id}/`,
  }),
})
